import styles from './CoachDashboardStats.module.scss'
import { UncontrolledPopover } from 'reactstrap'
import DefaultAvatar from '../../../assets/images/default_profile.png'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const POPOVER_HEADER = {
  1: 'dashboard.coach.statsItemPopover.headerLevel1',
  2: 'dashboard.coach.statsItemPopover.headerLevel2',
  3: 'dashboard.coach.statsItemPopover.headerLevel3',
  4: 'dashboard.coach.statsItemPopover.headerLevel4',
  5: 'dashboard.coach.statsItemPopover.headerLevel5',
  6: 'dashboard.coach.statsItemPopover.headerLevel6',
  7: 'dashboard.coach.statsItemPopover.headerLevel7',
  8: 'dashboard.coach.statsItemPopover.headerLevel8',
  9: 'dashboard.coach.statsItemPopover.headerLevel9',
  10: 'dashboard.coach.statsItemPopover.headerLevel10',
}


const StatsItemPopover = ({ divisionId, golfers }) => {
  const { t } = useTranslation()
  const golfersList = [...golfers]
  const sortedGolfers = golfersList.sort(
    (a, b) => b.division_attempts - a.division_attempts
  )

  return (
    <UncontrolledPopover
      placement='bottom'
      target={`Popover-${divisionId}`}
      trigger='legacy'
      className={styles.statsItemPopover}
    >
      <div className={styles.statsPopoverContainer}>
        <div className={styles.statsPopoverHeaderWrapper}>
          <p className={styles.statsPopoverHeader}>
            {t(POPOVER_HEADER[divisionId])}
          </p>
          <p className={styles.statsPopoverHeaderCount}>{t('dashboard.coach.statsItemPopover.attempts')}</p>
        </div>

        <div className={`p-2 ${styles.statsPopoverGolferWrapper}`}>
          {sortedGolfers?.length > 0 && sortedGolfers.map((g, index) => (
            <div
              className={`row mx-0 py-2 border-bottom ${styles.popoverGolferCard}`}
              key={index}
            >
              <div className={styles.popoverGolferWrapper}>
                <Link
                  className={styles.popoverGolfer}
                  to={`/profile/${g.golfer.id}`}
                  state={{ userId: g.golfer.id }}
                >
                  <img
                    src={
                      g.golfer.avatar ? g.golfer.avatar.file_url : DefaultAvatar
                    }
                    alt={`${g.golfer.first_name} ${g.golfer.last_name}`}
                    className='smaller-round-image-wrapper mr-1'
                  />
                </Link>
                <div>
                  <h6 className={`mb-0 ml-2 ${styles.popoverGolferName}`}>{`${g.golfer.first_name} ${g.golfer.last_name}`}</h6>
                </div>
              </div>
              <div className={styles.popoverAttemptsWrapper}>
                {g.division_attempts > 0 && (
                  <p className={styles.popoverAttempts}>{g.division_attempts}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </UncontrolledPopover>
  )
}

StatsItemPopover.propTypes = {
  divisionId: PropTypes.number,
  golfers: PropTypes.array,
}

export default StatsItemPopover
